module.exports = __webpack_public_path__ + "img/pic_huaweisteptwo.2a8e233b.png";